module.exports = __webpack_public_path__ + "img/share_tip.31685e89.png";